import { hubApiUrl } from "@/lib/hubApiOrigin";
import { resolvedHubLiveStreamOrigin, setRuntimeHubLiveStreamOrigin } from "@/lib/hubLiveStreamOrigin";

export type HubPublicConfig = {
  liveStreamOrigin: string | null;
};

let cached: HubPublicConfig | null = null;
let loadPromise: Promise<HubPublicConfig> | null = null;

function normalizeOrigin(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? "";
  if (trimmed === "") {
    return null;
  }
  return trimmed.replace(/\/$/, "");
}

export function getHubPublicConfigSnapshot(): HubPublicConfig | null {
  return cached;
}

export async function ensureHubPublicConfig(): Promise<HubPublicConfig> {
  if (cached != null) {
    return cached;
  }
  if (loadPromise != null) {
    return loadPromise;
  }
  loadPromise = (async () => {
    try {
      const response = await fetch(hubApiUrl("/api/hub/public-config"), {
        method: "GET",
        credentials: "include",
        cache: "no-store",
      });
      if (!response.ok) {
        const fallback = resolvedHubLiveStreamOrigin();
        cached = { liveStreamOrigin: fallback };
        setRuntimeHubLiveStreamOrigin(fallback);
        return cached;
      }
      const body = (await response.json()) as HubPublicConfig;
      const liveStreamOrigin = normalizeOrigin(body.liveStreamOrigin) ?? resolvedHubLiveStreamOrigin();
      cached = { liveStreamOrigin };
      setRuntimeHubLiveStreamOrigin(liveStreamOrigin);
      return cached;
    } catch {
      const fallback = resolvedHubLiveStreamOrigin();
      cached = { liveStreamOrigin: fallback };
      setRuntimeHubLiveStreamOrigin(fallback);
      return cached;
    } finally {
      loadPromise = null;
    }
  })();
  return loadPromise;
}

/** Test-only reset. */
export function resetHubPublicConfigForTests(): void {
  cached = null;
  loadPromise = null;
}
